import { FusaReply } from "@/types/replyTypes";
import { GetAllProductPageContentsResponse, CreateProductPageContentRequest, CreateProductPageContentResponse, UpdateProductPageContentRequest, UpdateProductPageContentResponse, ProductPageContentResponse } from "@/types/productPageContentTypes";
import { Client } from "./client";
import { ProductPageSectionType } from "@/backend/access/productPageSection/types";
import { ProductPageContentParams } from "@/backend/access/productPageContent/types";

export class ProductPageContentController {
  client: Client;

  constructor(client?: Client) {
    this.client = client || new Client();
  }

  read(id: string): Promise<ProductPageContentResponse> {
    return this.client.read(`/api/product-page-contents/${id}`);
  }

  getAllByProcedureInstance(procedureInstanceId: string, type: ProductPageSectionType): Promise<GetAllProductPageContentsResponse> {
    return this.client.read(`/api/product-page-contents/byProcedureInstanceAndType/${procedureInstanceId}/${type}`);
  }

  getAllContentsBySection(productPageSectionId: string): Promise<GetAllProductPageContentsResponse> {
    return this.client.read(`/api/product-page-contents/bySection/${productPageSectionId}`);
  }

  createProductPageContent(data: CreateProductPageContentRequest): Promise<CreateProductPageContentResponse> {
    return this.client.create('/api/product-page-contents', data);
  }

  updateProductPageContent(content: UpdateProductPageContentRequest): Promise<UpdateProductPageContentResponse> {
    return this.client.update(`/api/product-page-contents/${content.id}`, content);
  }

  duplicateProductPageContent(id: string): Promise<ProductPageContentResponse> {
    return this.client.create(`/api/product-page-contents/duplicate/${id}`, {});
  }

  orderProductPageContents(productPageContents: ProductPageContentParams[]): Promise<GetAllProductPageContentsResponse> {
    return this.client.update('/api/product-page-contents/order', { productPageContents });
  }

  deleteProductPageContent(id: string): Promise<FusaReply> {
    return this.client.delete(`/api/product-page-contents/${id}`);
  }
}
